export enum SleepClimateEnum {
  PERSPIRE = 'perspire',
  NORMAL_SLEEP = 'normal_sleep',
  ALLERGY = 'allergy',
}
